import { Button, Card, Tooltip } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

import { type UploadItem as Upload } from '@/hooks/useUploader';

import { UploadIcon } from './UploadIcon';
import { UploadInfo } from './UploadInfo';
import { UploadProgress } from './uploadProgress';

export const UploadItem = ({
  upload,
  abort,
  retry
}: {
  upload: Upload;
  done: boolean;
  abort: (id: string, filename: string) => void;
  retry: (id: string) => void;
}) => {
  return (
    <Card key={upload.id} size='small' type='inner'>
      <UploadProgress upload={upload} />

      <div className='data relative flex flex-row gap-2'>
        <UploadIcon fileName={upload.file.name} />

        <div className='flex flex-1 flex-col p-1'>
          <Tooltip title={upload.file.name}>
            <div className='text-content-title max-w-44 truncate sm:max-w-fit'>{upload.file.name}</div>
          </Tooltip>
          <UploadInfo upload={upload} />
        </div>

        <div className='flex items-center'>
          {upload.status === 'error' && (
            <Tooltip title='Tentar novamente'>
              <Button
                size='small'
                className='cursor-pointer'
                type='text'
                id={`file-${upload.id}`}
                shape='circle'
                icon={<Icon.Upload />}
                onClick={() => retry(upload.id)}
              />
            </Tooltip>
          )}

          <Tooltip title='Cancelar upload'>
            <Button
              shape='circle'
              color='default'
              variant='filled'
              icon={<Icon.Trash2Icon />}
              id={`file-${upload.id}`}
              disabled={upload.status === 'aborted'}
              onClick={() => abort(upload.deliverableId || upload.id, upload.file.name)}
            />
          </Tooltip>
        </div>
      </div>
    </Card>
  );
};
